import PropTypes from 'prop-types';
import { Box, Button, Container } from '@mui/material';
import FMSToolbar from 'src/common/FMSToolbar';
import FilterSelectInput from 'src/common/FilterSelectInput';
import { useState } from 'react';
import BreakdownForm from 'src/components/breakdown/BreakdownForm';
import BreakdownList from 'src/components/breakdown/BreakdownList';
import ReportFilterModal from 'src/components/reports/ReportFilterModal';
import { getReportConfig, REPORTS } from 'src/components/reports/reportService';
import { breakdownReportFormInitialValues, breakdownReportFormModel, breakdownReportValidationSchema } from 'src/components/breakdown/breakdownReportFormModel';
import DownloadIcon from '@mui/icons-material/FileDownloadOutlined';
import ScreenHeader from 'src/common/ScreenHeader';
import useAdminSiteFilter from 'src/hooks/useAdminSiteFilter';
import usePersistentListFilters from 'src/hooks/usePersistentListFilters';

const VehicleBreakdown = ({ location }) => {
  const {
    search, site, setSearch, setSite
  } = usePersistentListFilters();
  const {
    isAdmin,
    siteFilter,
    setSiteFilter,
    siteOptions
  } = useAdminSiteFilter(site);
  const [openModal, setOpenModal] = useState(false);
  const [searchText, setSearchText] = useState(search);
  const [searchFilters, setSearchFilters] = useState({});
  const [openReportModal, setOpenReportModal] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleSearch = (str) => { setSearchText(str); setSearch(str); };
  const downloadReport = () => setOpenReportModal(true);
  const onReportModalClose = () => setOpenReportModal(false);
  const reportConfig = getReportConfig(REPORTS.breakdown);

  return (
    <>
      <ScreenHeader title="Vehicle Breakdown" />
      <Box
        className="transaction-style-page"
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <FMSToolbar
            placeholder="Search Vehicle Number"
            actionName="Export"
            actionIcon={<DownloadIcon />}
            searchValue={searchText}
            onSearch={handleSearch}
            searchFields={[
              { key: 'vehicle__registration_num', label: 'Vehicle Number', defaultChecked: true },
              { key: 'type', label: 'Breakdown Type' },
              { key: 'location', label: 'Location' }
            ]}
            searchValues={searchFilters}
            onSearchFields={(values) => { setSearchFilters(values); setSearchText(''); setSearch(''); }}
            onClearSearchFields={() => { setSearchFilters({}); setSearchText(''); setSearch(''); }}
            onAction={downloadReport}
            onRefresh={() => setRefreshKey((value) => value + 1)}
            hideActionDivider
            actionButtonSize="small"
            actionButtonSx={{
              height: 40,
              minWidth: 145,
              px: 2,
              py: 1,
              fontSize: 14
            }}
            rightChildren={(
              <>
                {isAdmin && (
                  <FilterSelectInput
                    label="Site"
                    name="site"
                    size="small"
                    value={siteFilter}
                    data={siteOptions}
                    onInputChange={(value) => { setSiteFilter(value); setSite(value); }}
                    sx={{ width: { xs: '100%', sm: 220, md: 180 }, mr: 0 }}
                  />
                )}
                <Button
                  sx={{ height: 40, whiteSpace: 'nowrap' }}
                  color="primary"
                  size="small"
                  variant="contained"
                  onClick={() => setOpenModal(true)}
                >
                  Add Breakdown
                </Button>
              </>
            )}
            sx={{
              border: 'none !important',
              boxShadow: 'none !important',
              borderRadius: '0 !important',
              background: 'transparent',
              '&.MuiCard-root': {
                border: 'none !important',
                boxShadow: 'none !important',
                borderRadius: '0 !important'
              },
              '& .MuiCardContent-root': {
                px: 0,
                pt: 1,
                pb: 0
              }
            }}
          />
          <ReportFilterModal
            open={openReportModal}
            title="Vehicle Breakdown Report"
            formModel={breakdownReportFormModel}
            formValidation={breakdownReportValidationSchema}
            formInitValues={breakdownReportFormInitialValues}
            filterConfig={reportConfig.filterOptions}
            downloadUrl={reportConfig.downloadUrl}
            handleClose={onReportModalClose}
          />
          <BreakdownForm open={openModal} handleClose={() => setOpenModal(false)} />
          <Box sx={{ pt: 3 }}>
            <BreakdownList
              refreshData={refreshKey || location.state?.fromDashboard}
              searchText={searchText}
              searchFilters={searchFilters}
              siteFilter={siteFilter}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};

VehicleBreakdown.propTypes = {
  location: PropTypes.object
};

export default VehicleBreakdown;
